import { createSelector } from '@reduxjs/toolkit';

import { type RootState } from '~/redux/store';

export const selectFilters = (state: RootState) => state.filters;

export const selectDeliveryFilters = createSelector(
  [selectFilters],
  (filters) => ({
    dateRange: filters.delivery_dateRange,
    query: filters.delivery_query,
    selectedAcceptState: filters.delivery_selectedAcceptState,
    selectedArticle: filters.delivery_selectedArticle,
    selectedArticleNumber: filters.delivery_selectedArticleNumber,
    selectedCategory: filters.delivery_selectedCategory,
    selectedCostCenter: filters.delivery_selectedCostCenter,
    selectedCostCenters: filters.selectedCostCenters,
    selectedCustomerNumber: filters.delivery_selectedCustomerNumber,
    selectedCustomFields: filters.delivery_selectedCustomFields,
    selectedFromSite: filters.delivery_selectedFromSite,
    selectedNumber: filters.delivery_selectedNumber,
    selectedOuId: filters.delivery_selectedOuId,
    selectedPermittedCostCenters: filters.delivery_selectedPermittedCostCenters,
    selectedPermittedToSites: filters.delivery_selectedPermittedToSites,
    selectedPredefinedDateRange: filters.delivery_predefinedDateRange,
    selectedProcessState: filters.delivery_selectedProcessState,
    selectedRecipient: filters.delivery_selectedRecipient,
    selectedSettledStatus: filters.delivery_selectedSettledStatus,
    selectedSites: filters.selectedSites,
    selectedSource: filters.delivery_selectedSource,
    selectedSubmittedByUserId: filters.delivery_selectedSubmittedByUserId,
    selectedSupplier: filters.delivery_selectedSupplier,
    selectedToSiteRecipient: filters.delivery_selectedToSiteRecipient,
    selectedToSiteSupplier: filters.delivery_selectedToSiteSupplier,
    selectField: filters.delivery_selectField,
  }),
);
